import React, { useRef, useEffect } from "react";
import { FC, Props } from "./typings";
import { useTranslation } from "react-i18next";

const HtmlWithImages: FC<Props> = ({ htmlString }) => {
  const { t } = useTranslation();
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Find all images inside rendered HTML
    const images = containerRef.current.querySelectorAll("img");

    images.forEach((img: HTMLImageElement) => {
      // Remove existing listeners to avoid duplication
      img.onclick = null;
      img.style = "cursor: pointer;";

      img.addEventListener("click", () => {
        const src = img.getAttribute("src");

        if (src.startsWith("data:image")) {
          // For base64 data URLs, open a new window and inject the image
          const newTab = window.open();
          if (newTab) {
            newTab.document.write(
              `<html><head>
      <title>${t("common.preview")}</title>
    </head><body style="margin:0;display:flex;justify-content:center;align-items:center;background:#000;">
                 <img src="${src}" style="max-width:100%;max-height:100%;" />
               </body></html>`
            );
            newTab.document.close();
          }
        } else {
          // For normal URLs, open directly
          const absoluteUrl = new URL(src, window.location.href).href;
          window.open(absoluteUrl, "_blank", "noopener,noreferrer");
        }
      });
    });

    // Cleanup
    return () => {
      images.forEach((img) => {
        img.onclick = null;
      });
    };
  }, [htmlString]);

  return (
    <div ref={containerRef} dangerouslySetInnerHTML={{ __html: htmlString }} />
  );
};

export default HtmlWithImages;
